module.exports = __webpack_public_path__ + "static/img/rg-logo-nj.dcb76fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accounting/rg-logo-nj.svg
// module id = jMN/
// module chunks = 12